export default "__VITE_ASSET__$iwSq2Jj__"